import Image from "next/image";
import React, { FC } from "react";

interface LoadingSpinnerProps {}

const LoadingSpinner: FC<LoadingSpinnerProps> = () => {
  return (
    <div className="fixed inset-0 z-[200] flex flex-col gap-5 items-center justify-center bg-white bg-opacity-75">
      <div className="bg-white rounded-[40px] p-10  flex flex-col items-center gap-5 border-gray-50 border-2">
        <div className="relative h-28 w-[200px]">
          <Image
            src="/images/gte-logo.jpg"
            alt="Gte Connects"
            fill
            className="object-contain cursor-pointer"
            sizes="200px"
            priority
          />
        </div>
        <div className="w-12 h-12 border-8 border-blue-200 border-t-[#0b559f] rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
